import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { setTransactionValue } from 'bundles/apex/deals/form/store/deal/actions';

import DealField, { propTypes } from 'bundles/apex/deals/form/fields/field';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import { NON_DISCLOSURE_STATE_CODES } from 'components/state_select';
import { calculatesTransactionValue } from 'bundles/apex/deals/lease_terms/helpers';

export function TransactionValue({
  deal, hideForNonDisclosureStates, invalid, label, required, setTransactionValue,
}) {
  const showNonDisclosureWarning = hideForNonDisclosureStates && NON_DISCLOSURE_STATE_CODES.includes(deal.state);

  return (
    <ManagedFormGroup
      disabled={calculatesTransactionValue(deal)}
      feedback={showNonDisclosureWarning ? `${label} will not appear in the Data Mining Report` : false}
      hasError={invalid}
      label={label}
      required={required}
      type="currency"
      value={deal.transactionValue}
      onValueChange={setTransactionValue}
    />
  );
}

TransactionValue.propTypes = {
  ...propTypes,
  hideForNonDisclosureStates: PropTypes.bool,
  setTransactionValue: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  hideForNonDisclosureStates: !!state.features?.hideTransactionValueForNonDisclosureStates,
});

const mapDispatchToProps = {
  setTransactionValue,
};

export default connect(mapStateToProps, mapDispatchToProps)(DealField(TransactionValue, 'transactionValue'));
